export default {
  formFields: {
    fieldHelp: 'Klicken Sie, um die Beschreibung zu öffnen',
    defaultAbbreviation: 'df.: ',
    paramJSONContent: 'JSON-Inhalt',
    wrongInputValue: 'Fehlerhafter Wert für diesen Parameter.',
    notValidJsonString: 'Ungültiges JSON Objekt in :fieldName',
  }
}
